var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 29.2727L17.5 35L21.875 29.2727H30.0877C32.8007 29.2727 35 26.9934 35 24.1818V5.09091C35 2.27928 32.8007 0 30.0877 0H4.91228C2.1993 0 0 2.27928 0 5.09091V24.1818C0 26.9934 2.1993 29.2727 4.91228 29.2727H13.125ZM17.5 31.9243L20.9838 27.3636H30.0877C31.7833 27.3636 33.1579 25.9391 33.1579 24.1818V5.09091C33.1579 3.33364 31.7833 1.90909 30.0877 1.90909H4.91228C3.21667 1.90909 1.84211 3.33364 1.84211 5.09091V24.1818C1.84211 25.9391 3.21667 27.3636 4.91228 27.3636H14.0162L17.5 31.9243Z",
    fill: "#BDBDBD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.75439,
    y: 7.63635,
    width: 20.8772,
    height: 3.18182,
    rx: 1.59091,
    fill: "#BDBDBD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.75439,
    y: 12.7273,
    width: 20.8772,
    height: 3.18182,
    rx: 1.59091,
    fill: "#BDBDBD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.75439,
    y: 17.8182,
    width: 12.8947,
    height: 3.18182,
    rx: 1.59091,
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment_icon.3158ad0292a46dbcda1fc5fe1bd13497.svg";
export { ForwardRef as ReactComponent };